import React from "react"
import MiscContent from "../layouts/MiscContent"
import HomeHero from "../layouts/HomeHero/home-hero.component"
import FeaturedInBanner from "../layouts/FeaturedInBanner/featured-in-banner.component"
import OurMission from "../layouts/OurMission/our-mission.component"
import WhyUse from "../layouts/WhyUse/why-use.component"
import CopiaAppFeatures from "../layouts/CopiaAppFeatures/copia-app-features.component"
import ReceiveDonations from "../layouts/ReceiveDonations/receive-donations.component"
import NonprofitsHomeHero from "../layouts/NonprofitsHomeHero/nonprofits-home-hero.component"
import NonprofitGroup from "../layouts/NonprofitGroup/nonprofit-group.component"
import AboutUsLetter from "../layouts/AboutUsLetter/about-us-letter.component"
import AboutUsBanner from "../layouts/AboutUsBanner/about-us-banner.component"
import Investors from "../layouts/Investors/investors.component"
import OpenPositions from "../layouts/OpenPositions/open-positions.component"
import TitleBanner from "../layouts/TitleBanner/title-banner.component"
import Questions from "../layouts/Questions/questions.component"
import News from "../layouts/News/news.component"
import DownloadAppBanner from "../layouts/DownloadAppBanner/download-app-banner.component"
import HowWeHelp from "../layouts/HowWeHelp/how-we-help.component"
import SolutionsHero from "../layouts/SolutionsHero/solutions-hero.component"
import BannerSlider from "../layouts/BannerSlider/banner-slider.component"
import DonationsBanners from "../layouts/DonationsBanners/donations-banners.component"
import SolutionsFeatures from "../layouts/SolutionsFeatures/solutions-features.component"
import SolutionsScrollable from "../layouts/SolutionsScrollable/solutions-scrollable.component"

export const getPageLayout = layout => {
  const layoutName = layout?.fieldGroupName?.split("_").pop().trim()
  if (!layoutName) return null
  switch (layoutName) {
    case "MiscContent":
      return <MiscContent {...layout} />
    case "HomeHero":
      return <HomeHero {...layout} />
    case "FeaturedInBanner":
      return <FeaturedInBanner {...layout} />
    case "OurMission":
      return <OurMission {...layout} />
    case "WhyUse":
      return <WhyUse {...layout} />
    case "CopiaAppFeatures":
      return <CopiaAppFeatures {...layout} />
    case "ReceiveDonations":
      return <ReceiveDonations {...layout} />
    case "NonprofitsHomeHero":
      return <NonprofitsHomeHero {...layout} />
    case "NonprofitGroup":
      return <NonprofitGroup {...layout} />
    case "AboutUsLetter":
      return <AboutUsLetter {...layout} />
    case "AboutUsBanner":
      return <AboutUsBanner {...layout} />
    case "Investors":
      return <Investors {...layout} />
    case "OpenPositions":
      return <OpenPositions {...layout} />
    case "TitleBanner":
      return <TitleBanner {...layout} />
    case "Questions":
      return <Questions {...layout} />
    case "News":
      return <News {...layout} />
    case "DownloadAppBanner":
      return <DownloadAppBanner {...layout} />
    case "HowWeHelp":
      return <HowWeHelp {...layout} />
    case "SolutionsHero":
      return <SolutionsHero {...layout} />
    case "BannerSlider":
      return <BannerSlider {...layout} />
    case "DonationsBanners":
      return <DonationsBanners {...layout} />
    case "SolutionsFeatures":
      return <SolutionsFeatures {...layout} />
    case "SolutionsScrollable":
      return <SolutionsScrollable {...layout} />
  }
}
